module.exports = __webpack_public_path__ + "static/hostsoft_og_image-4a8e4f535acaa9fbcbc382d5edc51361.jpg";